import moment from "moment";
import {Marker, Polygon} from "react-google-maps";
import {getBigIcon, getColorIcon} from "../MapViewPage/IconProvider";
import React from "react";

const Markers = ({events, start, end, googleMapZoom}) => {
    const groupBy = (array, groupingFunction) => {
        return array?.reduce((result, value) => {
            const key = groupingFunction(value);
            (result[key] || (result[key] = [])).push(value);
            return result;
        }, {});
    };

    let grouppedEvents = groupBy(events, (c) => c.site_latitude)
    let markersCount = 0;

    const renderEventMarker = (e, i, spiderfiedCount) => {
        markersCount = markersCount + 1

        const defaultPosition = {lat: e.site_latitude, lng: e.site_longitude}
        const position = spiderfiedCount > 1 ? calculateSpiderfiedPosition(e, i, spiderfiedCount) : defaultPosition
        const markerNumber = events.sort((a, b) => Date.parse(a.start) - Date.parse(b.start)).findIndex(event => event.id === e.id) + 1

        return (
            <>
                <Marker
                    key={i}
                    position={position}
                    title={e.name}
                    icon={e.target
                        ? getBigIcon(e.backgroundColor, e.selected ? false : e.highlighted, markerNumber.toString())
                        : getColorIcon(e.selected ? '#f8e500' : e.backgroundColor, false, markerNumber.toString(), false, false, e.selected ? false : e.highlighted)
                    }
                    onClick={() => {
                        this.setState({scrollTime: this.getScrollTime(e)});
                        this.selectEvent(e);
                    }}
                    zIndex={e.selected ? 1000 : (e.id ? null : 1000)}
                />
                {defaultPosition !== position && (
                    <Polygon
                        paths={[defaultPosition, position]}
                        options={{
                            strokeColor: "#ff0000",
                            strokeOpacity: 0.9,
                            strokeWeight: 3
                        }}
                    />
                )}
            </>
        );
    }

    const calculateSpiderfiedPosition = (marker, markerIndex, spiderfiedCount) => {
        const zoom = googleMapZoom || 1

        const additionalIntercept = markerIndex >= 8 ? (markerIndex - 8) * 0.06 : 0;
        const radius = Math.exp(-0.674 * zoom + 4.287 + additionalIntercept)

        let offset
        let mockedMarkersCount

        switch (spiderfiedCount) {
            case 2:
                mockedMarkersCount = 5
                offset = 2
                break;
            case 3:
                mockedMarkersCount = 4
                offset = 1.5
                break;
            case 4:
                mockedMarkersCount = 3
                offset = 1
                break;
            case 5:
                mockedMarkersCount = 2
                offset = 0.5
                break;
            default:
                mockedMarkersCount = 0
                offset = 0.5
        }

        const angle = (2 * Math.PI / (spiderfiedCount + mockedMarkersCount)) * (markerIndex * offset);

        const lat = marker.site_latitude + radius * Math.cos(angle);
        const lng = marker.site_longitude + radius * Math.sin(angle);

        return {lat, lng};
    }


    return Object.values(grouppedEvents).map(events => {
        const markers = events.filter(e => e.site_latitude && !e.hasCopy && moment(e.start).isSameOrAfter(start) && moment(e.end).isSameOrBefore(end))
            .sort((a, b) => moment(a.start).diff(moment(b.start)))
        return markers.map((e, i) => renderEventMarker(e, i, markers.length))
    })
}

export default Markers